



























































































































































import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IActivityStatus as ITV } from "@/@types/admin/activity-status";
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IAlertState as IAlert } from "@/@types/speciaMessage/speciaMessage";
import { auth } from "@/config/host.config";
import {
  isRoomMediaHidden,
  isRoomLevelRenamedToCategory,
} from "@/services/featureConfig";

import MessageAlertForm from "@/components/forms/tv_admin/tv-mails/message-alert-form.vue";
import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";

@Component({
  components: {
    btns: ChangeDeliteButtons,
    MessageAlertForm,
  },
})
export default class RoomCard extends Vue {
  @Prop({ type: Object, default: null }) room!: IRoom;
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: Array, default: () => [] }) levels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) types!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) devices!: Array<ITV>;

  @Inject("mainPhotoFolder") readonly mainPhotoFolder!: string;
  @Inject("roomPlanFolder") readonly roomPlanFolder!: string;
  @Inject("firePlanFolder") readonly firePlanFolder!: string;

  get hiddenRoomMedia(): Array<string> {
    return ["main_photo", "room_plan", "fire_plan"].filter((media) =>
      isRoomMediaHidden(media)
    );
  }

  get roomLevelLabel(): string {
    return String(
      isRoomLevelRenamedToCategory()
        ? this.$t("Administration.hotel.buttons.add_room_level")
        : this.$tc("change.room_level", 1)
    );
  }

  get roomType(): string {
    const t = this.types.find((el) => el._id == this.room.type);
    if (t) return this.$getLocale(t.name);
    return this.room.type ? this.room.type : "";
  }

  get status(): string {
    const t = this.statuses.find((el) => el._id == this.room.status);
    if (t) return this.$getLocale(t.name);
    return this.room.status ? this.room.status : "";
  }

  get level(): string {
    const t = this.levels.find((el) => el._id == this.room.level);
    if (t) return this.$getLocale(t.name);
    return this.room.level ? this.room.level : "";
  }

  getInitials = (name: string): string => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  getTVVariant(id: string): string {
    const tv = this.tvs.find((el) => el._id == id);
    if (tv)
      return tv.status == "online"
        ? "online"
        : tv.status == "offline"
        ? "offline"
        : "unknown";
    return "unknown";
  }

  tvName(id: string): string {
    const tv = this.tvs.find((el) => el._id == id);
    if (tv) return tv.tv_name ? tv.tv_name : tv.room_number;
    return id ? id : "";
  }

  getDeviceVariant(id: string): string {
    const device = this.devices.find((el) => el._id == id);
    if (device)
      return device.status == "online"
        ? "online"
        : device.status == "offline"
        ? "offline"
        : "unknown";
    return "unknown";
  }

  deviceName(id: string): string {
    const device = this.devices.find((el) => el._id == id);
    if (device) return device.tv_name ? device.tv_name : device.room_number;
    return id ? id : "";
  }

  sawe(_id: string, _alert: Partial<IAlert>): void {
    // reserved
  }

  async send(alert: Partial<IAlert>): Promise<void> {
    const uri = auth.messages;
    const data = {
      users: this.room.tvs,
      alert,
    };
    try {
      const res = await this.$axios.post(uri, data);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$bvModal.hide("message-alert-form");
      }
    } catch (error) {
      console.log(error);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  close(): void {
    this.$emit("hide");
  }
}
